<template>
  <div v-if="data" class="as-live-score"
  :class="{
    'as-live-score--winning': data.isWinning,
    'as-live-score--losing': data.isLosing,
    'as-live-score--draw': data.isDraw,
  }"
  >{{ data.scores }}</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { IStandingsRow } from "~src/interfaces";

interface Props {
  standing: IStandingsRow;
}

const props = defineProps<Props>();

const data = computed(() => {
 const liveScore = props.standing.live_score;

  if (!liveScore) {
    return null;
  }

  let scores = "";
  let isWinning = false;
  let isLosing = false;
  let isDraw = false;
  const homeScore = liveScore?.home_scores[0];
  const awayScore = liveScore?.away_scores[0];
  if (liveScore?.home_team_id === props.standing.team_id) {
    scores = liveScore.home_scores[0] + "-" + liveScore.away_scores[0];
    if (homeScore > awayScore) {
      isWinning = true;
    } else if (homeScore < awayScore) {
      isLosing = true;
    } else {
      isDraw = true;
    }
  } else if (liveScore?.away_team_id === props.standing.team_id) {
    scores = liveScore.home_scores[0] + "-" + liveScore.away_scores[0];
    if (awayScore > homeScore) {
      isWinning = true;
      scores = liveScore.away_scores[0] + "-" + liveScore.home_scores[0];
    } else if (awayScore < homeScore) {
      isLosing = true;
      scores = liveScore.away_scores[0] + "-" + liveScore.home_scores[0];
    } else {
      isDraw = true;
    }
  }

  return {
    scores,
    isWinning,
    isLosing,
    isDraw,
  };
});

</script>

<script lang="ts">
export default {};
</script>
